import { Injectable } from '@angular/core';
import { ofType, Actions, createEffect } from '@ngrx/effects';
import { of, throwError } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import {
    EMsisdnProceduresActions,
    GetMsisdnProcedures,
    GetMsisdnProceduresFailure,
    GetMsisdnProceduresSuccess
} from '../actions/msisdn-procedures.actions';
import { Store} from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import { AbstractEffects } from '../../../shared/abstract.effects';
import { MsisdnProcedureService } from '../../services/msisdn-procedure.service';
import { MsisdnProcedureInterface } from '../../models/msisdn-procedure.interface';
import { LineInterface } from '../../models/line.interface';

@Injectable()
export class MsisdnProceduresEffects extends AbstractEffects {

    line: LineInterface = null;

    constructor(
        private actions: Actions,
        private msisdnProcedureService: MsisdnProcedureService,
        public override store: Store<any>
    ) {
        super(store);
    }

    getMsisdnProcedures = createEffect(() => this.actions.pipe(
        ofType<GetMsisdnProcedures>(EMsisdnProceduresActions.GetMsisdnProcedures),
        tap(params => { this.line = params.line; }),
        switchMap(() => this.msisdnProcedureService.get(this.line)),
        switchMap((response: Array<MsisdnProcedureInterface>) => of(new GetMsisdnProceduresSuccess(response))),
        catchError((error: HttpErrorResponse) => {
            if (401 === error.status || 403 === error.status) {
                this.ResendRequestWithNewToken(new GetMsisdnProcedures(this.line));
            } else if (500 <= error.status) {
                this.DisplayMessage('error_with_retry', 400, new GetMsisdnProceduresFailure());
            }
            return throwError(error);
        })
    ));
}
